import { useCallback, useReducer, useState } from 'react';
import { ICandidateSourcingPool } from '../types';
import {
  initialTableState,
  genericTableReducer
} from '../../Components/GenericTable/genericTableReducer';
import { candidatePoolAssignmentColumns } from '../CandidatePools/candidatePoolAssignmentConfig';
import { emailBatchColumns } from '../CandidatePools/emailBatchConfig';
import {
  candidateSourcingReducer,
  initialCandidateSourcingState
} from '../candidateSourcingReducer';
import CandidateSourcingApi from '../API';

export const useCandidatePoolModal = () => {
  const [selectedPool, setSelectedPool] = useState<ICandidateSourcingPool | undefined>(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTabValue, setModalTabValue] = useState(0);

  const [individualCandidatePoolsState, individualCandidatePoolsDispatch] = useReducer(
    genericTableReducer,
    initialTableState(candidatePoolAssignmentColumns, {
      sortBy: 'name',
      sortOrder: 'asc'
    })
  );

  const [emailsState, emailsDispatch] = useReducer(
    genericTableReducer,
    initialTableState(emailBatchColumns, {
      sortBy: 'sent_at',
      sortOrder: 'desc'
    })
  );

  const [candidateSourcingState, candidateSourcingDispatch] = useReducer(
    candidateSourcingReducer,
    initialCandidateSourcingState
  );

  const handlePoolClick = useCallback(async (poolId: number) => {
    try {
      const response = await CandidateSourcingApi.getCandidatePool(poolId);
      const poolData = response.res as ICandidateSourcingPool;
      setSelectedPool(poolData);
      setIsModalOpen(true);
      setModalTabValue(0);
    } catch (error) {
      console.error('Error fetching pool data:', error);
    }
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedPool(undefined);
    setModalTabValue(0);
  }, []);

  const handleSnackbarState = useCallback((snackbarState: any) => {
    console.log('Snackbar state:', snackbarState);
  }, []);

  return {
    selectedPool,
    isModalOpen,
    modalTabValue,
    individualCandidatePoolsState,
    individualCandidatePoolsDispatch,
    emailsState,
    emailsDispatch,
    candidateSourcingState,
    candidateSourcingDispatch,
    handlePoolClick,
    handleCloseModal,
    handleSnackbarState,
    setModalTabValue
  };
};
